import { put, takeLatest } from 'redux-saga/effects';

import { requestBrokerFirmOwners } from '../../services/broker/brokerOwner';
import { fetchBrokerFirmOwnersFailure, fetchBrokerFirmOwnersSuccess } from '../actions/broker/brokerOwner';
import { FETCH_BROKER_FIRM_OWNERS_REQUEST } from '../actions/broker/types';

export function* watchBrokerOwnerSaga() {
    yield takeLatest(FETCH_BROKER_FIRM_OWNERS_REQUEST, fetchBrokerFirmsOwners);
}

/**
 * @typedef {Object} PAYLOAD
 * @property {number} skip
 *
 * @typedef {Object} PARAMS
 * @property {PAYLOAD} payload
 *
 */

/**
 *
 * @param {PARAMS} param0
 */
function* fetchBrokerFirmsOwners({ payload }) {
    try {
        const response = yield requestBrokerFirmOwners(payload);
        yield put(fetchBrokerFirmOwnersSuccess(response));
    } catch (error) {
        yield put(
            fetchBrokerFirmOwnersFailure('Failed to get list of broker firms')
        );
    }
}
